// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"2741":"653c787f2490dc24","5443":"4b6455210b829ef8","6350":"d10e0995b520ef73","6390":"2712ceea0058883b","7856":"284508e5f767ae9d","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};